export const DATE_DISPLAY_PATTERNS = {
  monthFirst: 'MM/DD/YYYY',
  dayFirst: 'DD/MM/YYYY',
  monthName: 'MMM Do, YYYY',
  monthNameNumeric: 'MMM DD, YYYY',
} as const;

export const MONTH_FIRST_DATE_FORMAT_REGIONS = ['NORAM', 'US', 'LATAM'] as const;

export const MONTH_FIRST_DATE_FORMAT_REGION_SET = new Set<string>(MONTH_FIRST_DATE_FORMAT_REGIONS);

export const DEFAULT_DATE_FORMAT_REGION = 'NORAM';
